import * as React from 'react';
const SvgCurrencyDollar = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M10.547 16.791a.54.54 0 0 1-.394-.169.6.6 0 0 1-.169-.435v-1.014q-.9-.189-1.59-.702a3.3 3.3 0 0 1-1.038-1.239.55.55 0 0 1-.013-.456.53.53 0 0 1 .33-.321.9.9 0 0 1 .48-.015q.24.058.36.27.362.647.9 1.01.54.363 1.19.363.84 0 1.477-.481.638-.482.638-1.227 0-.705-.508-1.157t-1.635-.853q-1.682-.6-2.387-1.228-.704-.628-.704-1.72 0-.925.706-1.679.706-.753 1.794-.916v-1.01a.6.6 0 0 1 .159-.435.5.5 0 0 1 .383-.169q.224 0 .383.17a.6.6 0 0 1 .158.434v1.01q.664.08 1.222.384.559.303.929.845.14.227.082.452a.45.45 0 0 1-.274.317.75.75 0 0 1-.466.012.94.94 0 0 1-.446-.288 1.7 1.7 0 0 0-.645-.494 2.1 2.1 0 0 0-.88-.175q-.754 0-1.325.427-.572.426-.572 1.073 0 .581.533 1.038t1.956.955q1.477.511 2.112 1.185.633.674.633 1.838 0 1.012-.816 1.84t-2.043.988v.968a.6.6 0 0 1-.158.435.48.48 0 0 1-.363.17'
            />
        </g>
    </svg>
);
export default SvgCurrencyDollar;
